// <s-artist-directory> sorts the artist cards by last name and filters them with the
// caller-composed chips: each chip is a button[data-filter] holding comma-separated
// category handles, or "all". The pressed chip gets aria-pressed="true".

class SArtistDirectory extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const grid = this.querySelector('[data-artist-grid]');
    if (!grid) return;

    const cards = Array.from(grid.children);
    cards
      .sort((a, b) => (a.dataset.lastName || '').localeCompare(b.dataset.lastName || ''))
      .forEach((card) => grid.appendChild(card));
    // Re-sorting can leave the phone row snapped mid-way; start at the first card.
    requestAnimationFrame(() => { grid.scrollLeft = 0; });

    // Phones and tablets have no hover: the first tap on a card shows its quotes,
    // a second tap on the same card opens the artist's page. Tapping elsewhere closes it.
    const touchOnly = window.matchMedia('(hover: none)');
    this.addEventListener('click', (event) => {
      if (!touchOnly.matches) return;
      const link = event.target.closest('[data-artist-grid] > [data-category] > a');
      const card = link?.parentElement;
      if (!card || !this.contains(card)) return;
      if (card.hasAttribute('data-active')) return;
      event.preventDefault();
      this.querySelectorAll('[data-artist-grid] > [data-active]').forEach((open) => open.removeAttribute('data-active'));
      card.setAttribute('data-active', '');
    }, { signal: this.#ac.signal });

    document.addEventListener('click', (event) => {
      if (!touchOnly.matches) return;
      if (event.target.closest('[data-artist-grid] > [data-category]')) return;
      this.querySelectorAll('[data-artist-grid] > [data-active]').forEach((open) => open.removeAttribute('data-active'));
    }, { signal: this.#ac.signal });

    this.addEventListener('click', (event) => {
      const chip = event.target.closest('button[data-filter]');
      if (!chip || !this.contains(chip)) return;
      this.querySelectorAll('button[data-filter]').forEach((button) => {
        button.setAttribute('aria-pressed', button === chip ? 'true' : 'false');
      });
      chip.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      this.#apply(chip.dataset.filter || 'all');
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #apply(filter) {
    const wanted = filter.split(',').map((value) => value.trim()).filter(Boolean);
    this.querySelectorAll('[data-artist-grid] > [data-category]').forEach((card) => {
      const roles = (card.dataset.category || '').split(',');
      const show = filter === 'all' || wanted.some((role) => roles.includes(role));
      card.classList.toggle('hidden', !show);
    });
    // On phones the cards are a sideways row; start the new filter from the first card.
    const grid = this.querySelector('[data-artist-grid]');
    if (grid) grid.scrollLeft = 0;
  }
}

if (!customElements.get('s-artist-directory')) customElements.define('s-artist-directory', SArtistDirectory);
